import { ProfessionEntity } from '../entities/profession-entity';

export default class State {
  items: Array<ProfessionEntity> = [];
}
